<template>
    <v-card class="pa-3">
        <v-progress-linear
            v-if="loading"
            :indeterminate="true"
            color="success"
        ></v-progress-linear>
        <v-card-text v-if="!loading" class="px-0 pt-0">
            <!-- <div class="px-0 pb-4" style="border: #5cb860 1px solid">
                <v-layout
                    class="headline mb-4 px-2 py-2 font-weight-medium"
                    style="color: #fff; background-color: #5cb860; margin-left: -1px; margin-right: -1px"
                    layout
                    row
                    justify-space-between
                    >Current Year: {{ getCurrentYear(regID) }}</v-layout
                >
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Previous Balance:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ previousBalance | currency }}
                    </div>
                </v-layout>
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Billed:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ total | currency }}
                    </div>
                </v-layout>
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Paid:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ paid | currency }}
                    </div>
                </v-layout>
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Credit:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ credit | currency }}
                    </div>
                </v-layout>
                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Scheduled Payments:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ scheduledPayments | currency }}
                    </div>
                </v-layout>

                <v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Total Paid:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ totalPaid | currency }}
                    </div> </v-layout
                ><v-layout row justify-space-between class="pb-2 px-4">
                    <div class="heading font-weight-medium">
                        Actual Balance:
                    </div>
                    <div class="heading font-weight-medium">
                        {{ actualBalance | currency }}
                    </div>
                </v-layout>
                <v-layout
                    row
                    justify-space-between
                    class="px-4 mt-3 headline font-weight-bold"
                    style="color: #5cb860;"
                >
                    <div>
                        Total Balance:
                    </div>
                    <div>
                        {{ balance | currency }}
                    </div>
                </v-layout>
            </div> -->

            <div
                v-if="getPastYearsEnrollmentInfo().length"
                class="px-0 pb-0"
                style="border: #5cb860 1px solid"
            >
                <div
                    v-for="(year, index) in getPastYearsEnrollmentInfo()"
                    class="pt-2 px-0"
                    v-bind:class="{
                        'selected-year': isSelectedYear(year.regID),
                    }"
                >
                    <v-layout
                        class="headline mb-2 px-2 py-2 font-weight-medium"
                        style="color: #fff; background-color: #00bcd4; margin-left: -2px; margin-right: -2px"
                        layout
                        row
                        justify-center
                        v-if="isSelectedYear(year.regID)"
                        >{{ getCurrentYear(year.regID) }}</v-layout
                    >
                    <a
                        href=""
                        @click="navigateToOtherYear(year.regID)"
                        v-if="!isSelectedYear(year.regID)"
                        class="pb-2 text-xs-center year-link-text"
                        >{{ getCurrentYear(year.regID) }}</a
                    >
                    <v-layout row justify-space-between wrap class="pb-2 px-4">
                        <div class="heading font-weight-medium">
                            Previous Balance:
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.ykAccount.previousBalance | currency }}
                        </div>
                    </v-layout>
                    <v-layout row justify-space-between wrap class="pb-2 px-4">
                        <div class="heading font-weight-medium">
                            Billed:
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.ykAccount.debit | currency }}
                        </div>
                    </v-layout>
                    <v-layout
                        row
                        justify-space-between
                        class="pb-2 px-4"
                        v-if="isSelectedYear(year.regID)"
                    >
                        <div class="heading font-weight-medium">
                            Paid:
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.ykAccount.paid | currency }}
                        </div>
                    </v-layout>
                    <v-layout row justify-space-between class="pb-2 px-4">
                        <div class="heading font-weight-medium">
                            Credit:
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.ykAccount.credit | currency }}
                        </div>
                    </v-layout>
                    <v-layout
                        row
                        justify-space-between
                        class="pb-2 px-4"
                        v-if="isSelectedYear(year.regID)"
                    >
                        <div class="heading font-weight-medium">
                            Scheduled Payments:
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.ykAccount.scheduledPayments | currency }}
                        </div>
                    </v-layout>

                    <v-layout row justify-space-between wrap class="pb-2 px-4">
                        <div class="heading font-weight-medium">
                            Total Paid:
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.ykAccount.totalPaid | currency }}
                        </div>
                    </v-layout>
                    <v-layout
                        row
                        justify-space-between
                        wrap
                        class="pb-2 px-4"
                        v-if="isLastYear(year.regID)"
                    >
                        <div class="heading font-weight-medium">
                            Actual Balance:
                        </div>
                        <div class="heading font-weight-medium">
                            {{ year.ykAccount.actualBalance | currency }}
                        </div>
                    </v-layout>

                    <v-layout
                        row
                        justify-space-between
                        wrap
                        class="pb-2 px-4 title font-weight-bold"
                        style="color: #5cb860;"
                    >
                        <div>
                            Balance:
                        </div>
                        <div>
                            {{ year.ykAccount.currentTotalBalance | currency }}
                        </div>
                    </v-layout>
                    <div
                        class="px-2 mx-1"
                        v-bind:class="{
                            'mb-3':
                                isSelectedYear(year.regID) ||
                                index + 1 ==
                                    getPastYearsEnrollmentInfo().length,
                        }"
                    >
                        <table
                            id="enrollments"
                            class="mt-2"
                            v-if="year.enrollments.length"
                        >
                            <tr>
                                <th>Name</th>
                                <th>Reg Type</th>
                                <th>Amount</th>
                            </tr>
                            <tr v-for="enrollment in year.enrollments">
                                <td>{{ enrollment.name }}</td>
                                <td>{{ enrollment.regType }}</td>
                                <td>{{ enrollment.amount | currency }}</td>
                            </tr>
                        </table>
                    </div>

                    <v-divider
                        class="mt-3 pb-2"
                        v-if="
                            !isSelectedYear(year.regID) &&
                                index + 1 < getPastYearsEnrollmentInfo().length
                        "
                        :key="index"
                    ></v-divider>
                </div>
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    props: {
        regID: { type: String },
        loading: { type: Boolean },
        total: { type: Number },
        previousBalance: { type: Number },
        credit: { type: Number },
        paid: { type: Number },
        balance: { type: Number },
        totalPaid: { type: Number },
        scheduledPayments: { type: Number },
        actualBalance: { type: Number },
        pastYearsEnrollmentInfo: Array,
        account: Object,
    },
    data: () => ({
        terms: [],
    }),
    async created() {
        await this.loadRegTerms();
    },
    methods: {
        getCurrentYear(regID) {
            if (!regID) return;

            return regID.substring(3);
        },
        getPastYearsEnrollmentInfo() {
            return this.pastYearsEnrollmentInfo;

            // return this.pastYearsEnrollmentInfo.filter(
            //     (e) => e.regID != this.regID
            // );
        },
        isSelectedYear(regID) {
            return this.regID == regID;
        },
        isLastYear(regID) {
            const lastYear = this.pastYearsEnrollmentInfo.map(
                (a) => a.regID,
            )[0];

            return regID == lastYear;
        },
        async loadRegTerms() {
            const terms = await this.$http.get("api/yk/getRegTerms");

            this.terms = terms;
        },
        navigateToOtherYear(regID) {
            this.$router.push({
                name: "YKCAccountView",
                params: { id: this.account.accountID, reg_id: regID },
            });
        },
    },
};
</script>
<style>
.year-link-text {
    color: rgb(32, 166, 237);
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
    font-size: 20px;
}
#enrollments {
    border-collapse: collapse;
    width: 100%;
}

#enrollments td,
#enrollments th {
    border: 1px solid #ddd;
    padding: 8px;
}

#enrollments tr:nth-child(odd) {
    background-color: #f2f2f2;
}

#enrollments tr:hover {
    background-color: #ddd;
}

#enrollments th {
    padding-top: 4px;
    padding-bottom: 4px;
    text-align: left;
    background-color: #4caf50;
    color: white;
}

.selected-year {
    border: 2px solid #00bcd4;
}
</style>
